const AggressionNames = 
{
    Annex: "Annex",
    ArmedIntervention: "Armed Intervention",
    Enslave: "Enslave",
    Infiltrate: "Infiltrate",
    Kidnap: "Kidnap",
    Occupy: "Occupy",
    Plunder: "Plunder",
    Raid: "Raid",
    Spy: "Spy"
}

module.exports = AggressionNames;